import { faRectangleList } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Card,
  TextField,
  Typography,
} from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import companyArray from "./CompanyArray.json";
import { useFormik } from "formik";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import * as Yup from "yup";

import axios from "axios";
import { ShowError, ShowSucess } from "../../../_helper/helper";

import { useAuth } from "oidc-react";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    ".&.MuiExpansionPanelSummary-content": {
      padding: 0,
    },
    ".css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "32px",
      margin: "0px !important",
    },
    "& .MuiPaper-root": {
      background: "none",
      display: "block",
    },
    margin: "0 !important",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "70%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
}));

const NoticeDetail = () => {
  const classes = useStyles();

  const plan = {
    Applying: [
      { value: "Member/Employe", label: "Member/Employe" },
      { value: "Spouse", label: "Spouse" },
      { value: "Child", label: "Child" },
    ],
    Zender: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
    ],
    basic_plan: "Basic Life Insurance",
    basic_amount: "10000",
    basic_description: "Basic Life with AD&D $10,000 (Employer Paid) ",

    additional_plan: "Additional/Optional Life Insurance",
    additional_plan_decline: "Decline Additional/Optional Life with AD&D ",
    additional_amount: "10000",
    additional_description: "Basic Life with AD&D $10,000 (Employer Paid) ",
    additional_line1:
      "You may choose one of the following options for yourself:",
    additional_select:
      "Additional/Optional Life with AD&D (Employee Paid) (See Coverage Highlights for bi-weekly age-banded premium rates)",
    additional_amount: [
      { value: 30000, label: "$30,000" },
      { value: 35000, label: "$35,000" },
      { value: 40000, label: "$40,000" },
      { value: 45000, label: "$45,000" },
      { value: 50000, label: "$50,000" },
      { value: 55000, label: "$55,000" },
      { value: 60000, label: "$60,000" },
      { value: 65000, label: "$65,000" },
      { value: 70000, label: "$70,000" },
      { value: 75000, label: "$75,000" },
      { value: 80000, label: "$80,000" },
      { value: 85000, label: "$85,000" },
      { value: 90000, label: "$90,000" },
      { value: 95000, label: "$95,000" },
      { value: 100000, label: "$100,000" },
      { value: 105000, label: "$105,000" },
      { value: 110000, label: "$110,000" },
      { value: 115000, label: "$115,000" },
      { value: 120000, label: "$120,000" },
      { value: 125000, label: "$125,000" },
      { value: 130000, label: "$130,000" },
    ],
    dependents_plan: "Dependents Life Insurance",
    dependents_amount: "18000",
    dependents_decline: "Decline Spouse Life / Child(ren) Life",
    dependents_description:
      "Spouse Life $10,000 / Child(ren) Life $8,000 (Employee Paid) (See Coverage Highlights for bi-weekly premiums)",
  };

  const initialDependent = {
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    email: "",
    middleName: "",
  };

  const [selectedValue, setSelectedValue] = useState(null);
  const [dependentInformation, setDependentInformation] = useState([]);
  const [deletedDependent, setdeletedDependent] = useState([]);

  const handleCheckboxChange = (value) => {
    setSelectedValue(value);
    // console.log(value)
  };

  const [expanded, setExpanded] = React.useState({
    info: true,
    fruInfo: true,
  });

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };
  const { userData } = useAuth();

  const [show, setShow] = useState(true);
  const [loding, setLoading] = useState(false);
  const [defaultOpen, setDefaultOpen] = useState(true);

  const [schema, setPerformanceSchema] = useState({
    employee_no: Yup.string().required("Employee No. is required"),
    DOB: Yup.string().required("DOB is required"),
    last_name: Yup.string().required("Last Name is required"),
    ssn: Yup.string()
      .required("SSN is required")
      .test(
        "len",
        "Must be exactly 4 characters",
        (val) => val && val.toString().length === 4
      ),
  });

  const initialItem = {
    gender: "",
    employee_no: "",
    DOB: "",
    last_name: "",
    ssn: "",
    HealthVendor: "",
    healthPlan: "",
    UID: "",
    Employeetype: "",
    healthDeductionClass: "",
    subscriberId: "",
    id: "",
    amount: "",
    email: "",
    mailingAddress: "",
  };

  useEffect(() => {
    if (
      userData?.profile?.DOB &&
      userData?.profile?.EmployeeID &&
      userData?.profile?.LastName &&
      userData?.profile?.SSN
    ) {
      setLoading(true);
      searchEmployeeAPI(
        userData?.profile?.DOB,
        userData?.profile?.SSN,
        userData?.profile?.LastName,
        userData?.profile?.EmployeeID
      );
      setValues({
        ...values,
        DOB: userData?.profile?.DOB,
        employee_no: userData?.profile?.EmployeeID,
        last_name: userData?.profile?.LastName,
        ssn: userData?.profile?.SSN,
      });
    }
  }, [userData]);

  const handleUpdatePlan = () => {
    if (values?.UID && values?.healthPlan && values?.HealthVendor) {
      setLoading(true);
      const payload = {
        uid: values?.UID,
        healthVendor: values?.HealthVendor,
        healthPlan: values?.healthPlan,
        healthDeductionClass: values?.healthDeductionClass,
      };
      axios
        .put(
          `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/update`,
          [{ ...payload }],
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          ShowSucess("Successfully Updated.");
        })
        .catch((error) => {
          setLoading(false);
          ShowError("Internal Server Error !");
        });
    } else {
      ShowError("Please select any health plan");
    }
  };

  const getDependentList = async (employeeId) => {
    try {
      const getDependent = await axios.get(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/GetBySubscriberId?SubscriberId=${employeeId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      setDependentInformation(
        getDependent.data.length > 1
          ? getDependent.data.filter((i) => i.employeeId !== i.subscriberId)
          : [
            {
              ...initialDependent,
              subscriberId: employeeId,
              email: values?.email,
              mailingAddress: values?.mailingAddress,
              lastName: values?.last_name,
            },
          ]
      );
    } catch (error) {
      setDependentInformation([
        {
          ...initialDependent,
          subscriberId: employeeId,
          email: values?.email,
          mailingAddress: values?.mailingAddress,
          lastName: values?.last_name,
        },
      ]);
    }
    setdeletedDependent([]);
  };

  const searchEmployeeAPI = async (
    DOB = null,
    ssn = null,
    last_name = null,
    employee_no = null
  ) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/${moment(
          DOB
        ).format("YYYY-MM-DD")}/${ssn}/${last_name}/${employee_no}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then(async (res) => {
        const resData = res?.data?.length ? res?.data[0] : {};
        if (Object.keys(resData).length) {
          await getDependentList(resData.employeeId);
          // setShow(true);

          let searchData = {
            UID: resData?.uid,
            id: resData?.id,
            employee_no: resData?.employeeId,
            subscriberId: resData?.subscriberId,
            Employeetype: resData?.employeeType,
            HealthVendor: resData?.healthVendor,
            healthPlan: resData?.healthPlan,
            healthDeductionClass: resData?.healthDeductionClass,
            email: resData?.email,
            lastName: resData?.lastName,
            mailingAddress: resData?.mailingAddress,
          };
          setValues((state) => {
            return { ...state, ...searchData };
          });
        } else {
          ShowError("Employee Not Found !");
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        ShowError("Employee Not Found !");
      });
  };
  const onSubmit = (e) => {
    // API Calling
    setLoading(true);
    searchEmployeeAPI(
      values?.DOB,
      values?.ssn,
      values?.last_name,
      values?.employee_no
    );
  };

  const handleDependentUpdate = async () => {
    if (
      dependentInformation.some(
        (i) =>
          !i.firstName ||
          !i.lastName ||
          !i.middleName ||
          (i.uid ? false : !i.ssn || i["ssn"].length != 9) ||
          (values?.healthDeductionClass != "I" && !i.relation) ||
          !i.gender ||
          !i.dob
      )
    ) {
      ShowError("Please Check Dependent Information");
      return false;
    }

    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/CreateOrUpdateDeteteBenefits`,
        {
          createnupdate: [
            ...dependentInformation.map((i) => {
              i?.uid && delete i.ssn;
              return i;
            }),
            ...[
              {
                uid: values?.UID,
                healthVendor: values?.HealthVendor,
                healthPlan: values?.healthPlan,
                healthDeductionClass: await setClassValues(
                  dependentInformation
                ),
                subscriberId: values?.subscriberId,
                id: values?.id,
              },
            ],
          ],
          deletedList: deletedDependent,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then(async (response) => {
        await getDependentList(values?.employee_no);
        ShowSucess("Successfully Updated.");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleDependentDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    validateForm,
    setValues,
  } = useFormik({
    initialValues: initialItem,
    validationSchema: Yup.object().shape(schema),
    onSubmit,
  });

  const renderGroupCheckbox = (
    size = "large",
    stateName,
    value,
    other = null
  ) => {
    let defaultChk = (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
    if (other && other.matchkey && other.matchkey1) {
      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue &&
            values[other.matchkey1] == other.matchvalue1
          }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "healthDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "HealthVendor" &&
              other?.changeTarget2 == "healthPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
              // setFieldValue("amount", other?.amount);
            }

            setFieldValue(stateName, value);
          }}
        />
      );
    } else if (other && other.matchkey) {
      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue
          }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "healthDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "HealthVendor" &&
              other?.changeTarget2 == "healthPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
            }
            if (stateName == "healthPlan" && other.matchkey) {
              setFieldValue(
                "healthDeductionClass",
                values.healthDeductionClass
              );
            }
            setFieldValue(stateName, value);
          }}
        />
      );
    } else {
      defaultChk = (
        <Checkbox
          size={size}
          checked={values[stateName] == value}
          onChange={(e) => {
            setFieldValue(stateName, value);
          }}
        />
      );
    }
    return defaultChk;
  };
  const renderCheckbox1 = (index, size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={stateName == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      // checked={dependentInformation[index][stateName] == value}
      // onChange={(e) => {
      //   let data = [...dependentInformation];
      //   data[index][stateName] = value;
      //   setDependentInformation(data);
      // }}
      />
    );
  };
  function renderTextInput(stateName, label, others = {}) {
    let other = {
      disabled: false,
      maxLength: "",
      multiline: false,
      required: false,
      shrink: true,
      ...others,
    };
    let { disabled, maxLength, multiline, required, shrink } = other;
    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
          },
          readOnly: disabled,
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={values[stateName]}
        InputLabelProps={{ shrink: shrink ? shrink : false }}
        shrink={shrink ? shrink : false}
        onChange={(e) => {
          if (!disabled) {
            // setShow(false);
            handleChange(e);
          }
        }}
        onBlur={handleBlur}
        error={!disabled && touched[stateName] && errors[stateName]}
        helperText={
          !required && !disabled && touched[stateName] && errors[stateName]
        }
        disabled={disabled}
        required={required}
      />
    );
  }

  function renderDateInput(
    stateName,
    label,
    disabled = false,
    minDate = null
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={values[stateName]}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD hh:mm:ss")
              : null;
            // setShow(false);
            setFieldValue(stateName, date);
          }}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              error={!disabled && errors[stateName]}
              helperText={!disabled && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  function renderDropDown(stateName, label, value, disabled) {
    return (
      <div>
        <TextField
          margin="dense"
          className="flex w-full  mt-2"
          variant="outlined"
          select
          SelectProps={{ native: true }}
          style={{ width: "100%" }}
          size="small"
          disabled={disabled}
          inputProps={{
            style: {
              fontSize: "14px",
              color: "black",
              paddingTop: "12px",
            },
          }}
          label={label}
          name={stateName}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            handleChange(e);
          }}
          error={!disabled && errors[stateName]}
          helperText={!disabled && errors[stateName]}
          value={values[stateName]}
        >
          {/* <option value={""} disabled> */}
          {/* value={values[stateName]}> */}
          <option value={""} disabled>
            Select {label}
          </option>

          {value.length &&
            value.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
        </TextField>
      </div>
    );
  }

  const renderCheckbox = (size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
  };

  const setAmount = (currentClass) => {
    let getAmount = companyArray
      .find((item) => item.vendor_name == values?.HealthVendor)
      ?.vendor_items.find((item) => item.vendor_code == values?.healthPlan)
      ?.classInfo.find((ite) => ite.value == currentClass)?.amount;
    setFieldValue("amount", getAmount);
  };

  const setClassValues = async (dependentArray) => {
    const uniqueValues = [
      ...new Set(dependentArray.map((obj) => obj.relation)),
    ];

    if (uniqueValues.every((i) => i == "")) {
      if (values?.healthDeductionClass != "I") {
        setAmount("I");
        ShowSucess(`Class changed ${values?.healthDeductionClass} to I `);
        setFieldValue("healthDeductionClass", "I");
      }
      return "I";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.every((i) => ["spouse", "domesticpartner"].includes(i))
        : uniqueValues.every(
          (i) => ["spouse", "domesticpartner"].includes(i) || i == ""
        )
    ) {
      if (values?.healthDeductionClass != "II") {
        setAmount("II");
        ShowSucess(`Class changed ${values?.healthDeductionClass} to II `);
        setFieldValue("healthDeductionClass", "II");
      }
      return "II";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.every((i) => ["child"].includes(i))
        : uniqueValues.every((i) => i == "child" || i == "")
    ) {
      if (values?.healthDeductionClass != "III") {
        setAmount("III");
        ShowSucess(`Class changed ${values?.healthDeductionClass} to III`);
        setFieldValue("healthDeductionClass", "III");
      }
      return "III";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.some((i) => ["spouse", "domesticpartner"].includes(i)) &&
        uniqueValues.some((i) => ["child"].includes(i))
        : uniqueValues.some(
          (i) => ["spouse", "domesticpartner"].includes(i) || i == ""
        ) && uniqueValues.some((i) => ["child"].includes(i))
    ) {
      if (values?.healthDeductionClass != "IV") {
        setAmount("IV");
        ShowSucess(`Class changed ${values?.healthDeductionClass} to IV `);
        setFieldValue("healthDeductionClass", "IV");
      }
      return "IV";
    }
  };

  const getDateDifference = () => {
    const currentYear = moment().year();
    const defaultDate = moment(`09-30`, "MM-DD").year(currentYear);
    const currentDate = moment().year(currentYear);

    // Adjust the year for selectedDate if it is before constDate
    if (defaultDate.isBefore(currentDate)) {
      defaultDate.add(1, "year");
    }

    // Calculate the difference in days
    const diffDays = defaultDate.diff(currentDate, "days");

    return { diffDays, defaultDate, currentDate };
  };

  return (
    <div>
      {/* INFORMATION PRACTICES NOTICE    details */}
      <Card style={{ marginTop: "10px" }}>
        <Accordion
          className={classes.root}
          expanded={expanded.info}
          onChange={handleChangeExpanded("info")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="sub-header w-100 p-1 bg-primary text-white"
            style={{ width: "100%" }}
          >
            <FontAwesomeIcon
              icon={faRectangleList}
              className="sub-header"
              style={{
                // color: "#1569C7",
                marginRight: "10px",
                marginTop: "3px",
              }}
            />
            <Typography
              className={classes.heading}
              style={{ height: "auto" }}
            >
              INFORMATION PRACTICES NOTICE
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="p-0 page-body-wrapper">
            <Card style={{ padding: "20px" }}>
              <Col>
                <ul
                  style={{
                    listStyleType: "disc",
                    marginLeft: "12px",
                    marginBottom: "10px",
                    fontSize: "13px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <li>
                      To help us determine your eligibility for group
                      insurance we may request information about you from
                      other persons and organizatios. For examle, we may
                      request infom1ation from your doctor or hospital, other
                      insurance companies, or MIB, Inc. (MIB), formerly known
                      as Medical lnfom1at1on Bureau. We will use the
                      authorization you signed on this form when we seek this
                      information.
                    </li>
                    <li>
                      Ml B-Information regarding your insurability will be
                      treated as confidential. Standard Insurance Company or
                      its reinsurers may, however, make a brief report thereon
                      to MIB, a not-for-profit membership organization of
                      insurance companies, which operates an information
                      exchange on behalf of its Members. If you apply to
                      another MIB Member company for life or health Oncluding
                      short and long term disability) insurance coverage, or a
                      claim for benefits is submitted to such a company, MIB,
                      upon request, will supply such company with the
                      information in its file. Upon receipt of a request from
                      you, MIB will arrange disclosure of any information it
                      may have in your file. Please contact MIB at 866-
                      692-6901. If you question the accuracy of information in
                      MIB's file, you may contact MIB and seek a correction in
                      accordance with the procedures set forth in the federal
                      Fair Credit Reporting Act. The address of MIB's
                      information office is: 50 Braintree Hill Park, Suite
                      400, Braintree, Massachusetts 02184-8734. Standard
                      Insurance Company may release information in its file to
                      its reinsurers, and Standard Insurance Company, or its
                      reinsurers, may release information in its file to other
                      insurance companies to whom you may apply for life or
                      health (including short and long term disability)
                      insurance, or to whom a claim for benefits may be
                      submitted. Information for consumers about MI B may be
                      obtained on its website at www.mib.com.
                    </li>
                    <li>
                      DISCLOSURE TO OTHERS- The information collected about
                      you is confidential. We will not release any information
                      about you without your authorization, except to the
                      extent necessary to conduct our business or as required
                      or permitted by law
                    </li>
                    <li>
                      YOUR RIGHTS - You have a right to know what information
                      we have about you in our undel"Nriting file. You also
                      have a right to ask us to correct any information you
                      think is incorrect. We will carefully review your
                      request and make changes when justified. If you would
                      like more information about this right or our
                      information practices please write to us at Medical
                      Unde1V1riting, Standard Insurance Company, 900 SW Fifth
                      Avenue, Portland, Oregon 97204 or call 1-800-843-7979.
                    </li>
                  </div>
                </ul>
              </Col>
            </Card>
          </AccordionDetails>
        </Accordion>
      </Card>
      {/* INFORMATION PRACTICES NOTICE   details */}
      {/* FRAUD NOTICE     details */}
      <Card style={{ marginTop: "10px" }}>
        <Accordion
          className={classes.root}
          expanded={expanded.fruInfo}
          onChange={handleChangeExpanded("fruInfo")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="sub-header w-100 p-1 bg-primary text-white"
            style={{ width: "100%" }}
          >
            <FontAwesomeIcon
              icon={faRectangleList}
              className="sub-header"
              style={{
                // color: "#1569C7",
                marginRight: "10px",
                marginTop: "3px",
              }}
            />
            <Typography
              className={classes.heading}
              style={{ height: "auto" }}
            >
              FRAUD NOTICE
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="p-0 page-body-wrapper">
            <Card style={{ padding: "20px" }}>
              <Col>
                <ul
                  style={{
                    listStyleType: "disc",
                    marginLeft: "12px",
                    marginBottom: "10px",
                    fontSize: "13px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <li>
                      ARKANSAS, MAINE, OHIO; Some states require us to inform
                      you that any person who knowingly and with intent to
                      injure, defraud or deceive an insurance company, or
                      other person, files a statement containing false or
                      misleading information concerning any fact material
                      hereto commits a fraudulent insurance act which is
                      subject to civil and/or criminal penalties, depending
                      upon the state. Such actions may be deemed a felony and
                      substantial fines may be imposed.
                    </li>
                    <li>
                      COLORADO: It is unlawful to knowingly provide false.
                      incomplete or misleading facts or information to an
                      insurance company for the purpose of defrauding or
                      attempting to defraud the company. Penalties may include
                      imprisonment, fines, denial of insurance, and civil
                      damages. Any insurance company or agent of an insurance
                      company who kindly provides false, incomplete, or
                      misleading facts or information to the policyholder or
                      claimant for the purpose of defrauding or attempting to
                      defraud the policyholder or claimant with regard to a
                      settlement or award payable from insurance proceeds
                      shall be reported to the Colorado division of insurance
                      within the department of regulatory agencies.
                    </li>
                    <li>
                      DISTRICT OF COLUMBIA: It is a crime to provide false or
                      misleading information to an insurer for the purpose of
                      defrauding the insurer or any other person. Penalties
                      include imprisonment and/or fines. In addition, an
                      insurer may deny insurance benefits if false information
                      materially related to a claim was provided by the
                      applicant.
                    </li>
                    <li>
                      KENTUCKY: Any person who knowingly and with intent to
                      defraud any insurance company or other person files an
                      application for insurance containing any materially
                      false information or conceals, for the purpose of
                      misleading, information concerning any fact material
                      thereto commits a fraudulent insurance act, which is a
                      crime.
                    </li>
                    <li>
                      LOUISIANA, NEW MEXICO: Any person who knowingly and
                      willfully presents a false or fraudulent claim for
                      payment of a loss or benefit or who knowingly and
                      willfully presents false information in an application
                      for insurance is guilty of a crime and may be subject to
                      fines and confinement in prison.
                    </li>
                    <li>
                      MARYLAND, RHODE ISLAND: Any person who knowingly or
                      willfully presents a false or fraudulent claim for
                      payment of a loss or benefit or who knowingly or
                      willfully presents false information in an application
                      for insurance is guilty of a crime and may be subject to
                      fines and confinement in prison.
                    </li>
                    <li>
                      NEW JERSEY: Any person who includes any false or
                      misleading information on an application for an
                      insurance policy is subject to criminal and civil
                      penalties.
                    </li>
                    <li>
                      NEW YORK; Any person who knowingly and with intent to
                      defraud any insuranc company or other person files an
                      application for insurance or statement of claim
                      containing any materially false information, or conceals
                      for the purpose of misleading, information concerning
                      any fact material thereto commits a fraudulent act,
                      which is a crime, and shall be subject to a civil
                      penalty not to exceed five thousand dollars and the
                      stated value of the claim for each such violation.
                    </li>
                    <li>
                      PENNSYLVANIA: Any person who knowingly and with intent
                      to defraud any insurance company or other person files
                      an application for insurance or statement of claim
                      containing any materially false information or conceals
                      for the purpose of misleading, information concerning
                      any fact material thereto commits a fraudulent insurance
                      act, which is a crime and subjects such person to
                      criminal and civil penalties.
                    </li>
                    <li>
                      PUERTO RICO: Any person who knowingly and with the
                      intention to defraud includes false information in an
                      application for insurance or file, assist or abet in the
                      filing of a fraudulent claim to obtain payment of a loss
                      or any other benefit, or files more than one claim for
                      the same loss or damage, commits a felony and if found
                      guilty shall be punished for each violation with a fine
                      of no less than five thousand dollars ($5,000), not to
                      exceed ten thousand dollars ($10,000); or imprisoned for
                      a fixed term of three (3) years, or both. If aggravating
                      circumstances exist, the fixed jail term may be
                      increased to a maximum of five (5) years; if mitigating
                      circumstances are present, the jail term may be reduced
                      to
                    </li>
                    <li>
                      TENNESSEE, VIRGINIA, WASHINGTON: It is a crime to
                      knowingly provide false, incomplete, or misleading
                      information to an insurance company for the purpose of
                      defrauding the company. Penalties include imprisonment,
                      fines, and denial of insurance benefits.
                    </li>
                  </div>
                </ul>
              </Col>
            </Card>
          </AccordionDetails>
        </Accordion>
      </Card>
      {/* FRAUD NOTICE    details */}

    </div>
  );
};

export default NoticeDetail;
